import { Theme } from '@mui/material';
import { resolveTypographyVariantStyles } from '@aspendental/themes';

import { Maybe } from '@/types/generated';

export const getGridContainerStyles = (theme: Theme, variant?: Maybe<string>) => ({
	...(variant === 'TeamTag'
		? { background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 24.57%, rgba(0, 0, 0, 0.30) 100%), #002C5C ' }
		: {}),
	[theme.breakpoints.up('lg')]: { padding: '3.75rem 5%' },
	[theme.breakpoints.down('lg')]: { padding: '3.75rem 2%' },
	[theme.breakpoints.down('md')]: {
		padding: '2.5rem 1.25rem',
	},
});

export const getGridItemStyles = (isSmall: boolean) => ({
	'&.MuiGrid-item': {
		paddingY: isSmall ? '1.25rem' : '2.5rem',
	},
});

export const getEyebrowStyles = (theme: Theme, variant: string) => ({
	...resolveTypographyVariantStyles(theme, 'bodyMediumBook'),
	color: variant === 'TeamTag' ? 'neutrals.white' : 'text.secondary',
	[theme.breakpoints.down('md')]: {
		...resolveTypographyVariantStyles(theme, 'bodySmallBook'),
		color: variant === 'TeamTag' ? 'neutrals.white' : 'text.secondary',
	},
});

export const getHeadingStyles = (theme: Theme, variant: string) => ({
	...resolveTypographyVariantStyles(theme, 'header1'),
	color: variant === 'TeamTag' ? 'neutrals.white' : 'text.secondary',
	textAlign: 'center' as const,
});

export const paddingStyles = (isPaddingNeeded: boolean) => (isPaddingNeeded ? { padding: '0% 20%' } : {});

export const normalButtonsStyles = {
	display: 'flex',
	flexWrap: 'wrap',
	justifyContent: 'center',
	gap: '1rem',
	'&.MuiGrid-item': { paddingTop: '1.25rem' },
};
